module.exports = __webpack_public_path__ + "static/media/UG.b1e93965.png";